import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class PromptUpdateService {

  constructor(updates: SwUpdate) {
    if (!updates.isEnabled) {

      updates.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(event => {

        // if (promptUser(event)) {
           updates.activateUpdate().then(() => {

            alert('There is a new update available. Reloading the app. Please wait.');
            document.location.reload();
            });
        // }
      });
      

    }
  }
}
